const getters = {
  getFreelancerCategories(state) {
    return state.freelancerCategories
  },
  getSourcingToken(state) {
    return state.sourcingRequestToken
  },
  getOrderSummary(state) {
    return state.orderSummaryRecord 
  },
  getUserData(state) {
    return state.userData
  },
  getCurrentTab(state) {
    return state.currentTab
  }
}

export default getters
